<template>
  <div>
    <div class="container text-left">
      <div class="row">
        <div class="col-lg-12">
          <BreadcrumbsHelper class="sn-bread" :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <b-card class="mt-2">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="title">{{ net.name }}</h1>
              </div>
              <div class="col-lg-6 text-right">
                <router-link v-if="$store.state.auth.user.role === 'admin' && this.loaded" :to="{ name: 'social networks edit', params: { netId: net._id } }">
                  <button class="btn btn-secondary"><font-awesome-icon icon="edit" /> Edit</button>
                </router-link>
              </div>
            </div>
            <div class="details">
              <div><b>Name:</b> {{ net.name }}</div>
              <div>
                <b>Base url: </b> <a :href="net.base_url" alt="Opens in a new window" rel="external noopener noreferrer" target="_blank">{{ net.base_url }}</a>
              </div>
              <div><b>Logo:</b></div>
              <img class="logo" :src="`https://alabama-travel.s3.amazonaws.com/partners-uploads/social_network/image/${net._id}/${net.image}`" />
            </div>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    BreadcrumbsHelper,
  },
  data() {
    return {
      net: {},
      Breadcrumbs: [
        {
          text: 'Settings',
          active: true,
        },
        {
          text: 'Social Networks',
          href: '/social-networks',
        },
        {
          text: '',
          active: true,
        },
      ],
      loaded: false,
    };
  },
  props: {
    netId: String,
  },
  async created() {
    await this.loadSocialNetwork();
    this.Breadcrumbs[2].text = `${this.net.name} Detail`;
  },
  methods: {
    async loadSocialNetwork() {
      const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/socialNetworks/${this.netId}`);
      this.net = response.data;
      this.loaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: none;
}
.card-body h1 {
  margin: 0px !important;
  line-height: 4rem;
}
.details {
  color: black;
  margin-left: 15px;
}
.icon {
  color: black;
  font-size: 12px;
  line-height: 30px !important;
  padding-right: 2px;
  text-align: center;
}
.logo {
  height: 200px;
  margin-top: 30px;
  width: 200px;
}
.title {
  color: var(--blue-900);
  margin: 0px 390px 85px 15px;
}
</style>
